<template>
  <!-- ELO Chart -->
  <div
    v-if="!loading && hasData"
    @click="$emit('chartClick', chartType)"
    :class="[isActive ? 'outline-primary-500 outline' : '']"
    class="flex flex-1 py-2 items-center justify-center rounded-lg relative bg-gray-900 cursor-pointer duration-300"
  >
    <DoughnutChart
      class="w-[208px] h-[208px]"
      :chartData="chartData"
      :options="chartOptions"
    />
    <div
      class="absolute w-full h-full top-0 left-0 flex flex-col items-center justify-center mt-3"
    >
      <Pill
        v-if="rankPercentage > 0"
        class="px-2 py-[2px] mb-3"
        :text="rankPercentageString"
        :bgColor="`${percentageColor}30`"
        :textColor="percentageColor"
      />
      <h2 class="text-text-secondary">{{ title }}</h2>
      <h1 class="text-text-primary font-semibold text-4xl">
        {{ eloValue }}
      </h1>
    </div>
  </div>

  <!-- ELO Chart Loading -->
  <div
    v-else
    class="flex flex-1 py-2 items-center justify-center rounded-lg relative bg-gray-900"
  >
    <div class="w-[208px] h-[208px] rounded-full bg-gray-800 animate-pulse" />
    <div class="absolute w-full h-full top-0 left-0 flex flex-col items-center justify-center mt-3">
      <div class="w-16 h-6 bg-gray-700 rounded-full mb-3 animate-pulse" />
      <div :class="titleSkeletonWidth" class="h-4 bg-gray-700 rounded mb-2 animate-pulse" />
      <div class="w-16 h-10 bg-gray-700 rounded animate-pulse" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DoughnutChart } from 'vue-chart-3';
import Pill from '../Pill.vue';

const props = defineProps({
  chartType: {
    type: String,
    required: true, // 'quickfire' or 'prefire'
  },
  title: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  hasData: {
    type: Boolean,
    default: false,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  chartData: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
  eloValue: {
    type: [Number, String],
    default: 0,
  },
  rankPercentage: {
    type: Number,
    default: 0,
  },
  rankPercentageString: {
    type: String,
    default: '',
  },
  percentageColor: {
    type: String,
    default: '#6B70D1',
  },
});

defineEmits(['chartClick']);

const titleSkeletonWidth = computed(() => (props.chartType === 'quickfire' ? 'w-24' : 'w-20'));
</script>
